<div class="custom-modal">
  <div class="header">
      <h1 mat-dialog-title>
          Dados de Contagem de Inventário
      </h1>
  </div>
  <mat-divider></mat-divider>
    <mat-progress-bar color="primary" mode="indeterminate" [hidden]="!isLoading"></mat-progress-bar>
      <mat-card>
        <mat-card-header class="header-padrao">
          <mat-card-title>
            <mat-form-field class="flag-width flag-notification">
              <mat-label>Número</mat-label>
              <input matInput disabled [value]="inventarioId || '-'" />
            </mat-form-field>
            <mat-form-field class="flag-width flag-notification">
              <mat-label>Agente</mat-label>
              <input matInput disabled [value]="agente || '-'" />
            </mat-form-field>
            <mat-form-field class="flag-width flag-notification">
              <mat-label>IATA</mat-label>
              <input matInput disabled [value]="codIATA || '-'" />
            </mat-form-field>
            <mat-form-field class="flag-width flag-notification">
                <mat-label>Contagem</mat-label>
                <input matInput disabled [value]="numeroContagem || '-'" />
              </mat-form-field>
              <mat-form-field class="flag-width flag-notification">
                <mat-label>Data Criação</mat-label>
                <input matInput disabled [value]="dataCriacaoContagem || '-'" />
              </mat-form-field>                          
              <mat-form-field class="flag-width flag-notification">
                <mat-label>Criado Por</mat-label>
                <input matInput disabled [value]="criadoPorContagem || '-'" />
              </mat-form-field>              
          </mat-card-title>
        </mat-card-header>
      </mat-card>

    <app-itens-inventariados [numero]="inventarioContagemId"></app-itens-inventariados>

    <app-itens-faltas *ngIf="perfilAcessoTipoId !==4" [numero]="inventarioContagemId"></app-itens-faltas>

    <app-itens-sobra *ngIf="perfilAcessoTipoId !==4" [numero]="inventarioContagemId"></app-itens-sobra>

    <div class="modal-actions" mat-dialog-actions align="end">
      <button mat-flat-button color="primary" (click)="fechar()">Fechar</button>
    </div>    
    <div class="modal-actions" mat-dialog-actions align="end">
      <button mat-flat-button color="primary">
        <a class="link-download" matTooltip="Exportar para o Excel" [attr.href]="excelUrl" download>
          Exportar Excel
        </a>        
      </button>
    </div>
    <div class="modal-actions" mat-dialog-actions align="end">
      <button mat-flat-button color="primary">
        <a class="link-download" matTooltip="Exportar para o Excel" [attr.href]="pdfUrl" download>
          Exportar PDF
        </a>       
      </button>
    </div> 
</div>
